import { useQuery } from '@tanstack/react-query';
import { earlyAccessApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { EarlyAccessFilters } from '../types/early-access';

export function useEarlyAccessSignups(filters: Partial<EarlyAccessFilters>) {
  return useQuery({
    queryKey: queryKeys.earlyAccessSignups.list(filters),
    queryFn: () => earlyAccessApi.listSignups(filters),
    placeholderData: (previousData) => previousData,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
